/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { DistanceCalculationRequest } from '../models';
// @ts-ignore
import type { DistanceCalculationResponse } from '../models';
/**
 * CalculationServiceDistanceApi - axios parameter creator
 */
export const CalculationServiceDistanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate distance between waypoints
         * @param {DistanceCalculationRequest} distanceCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDistance: async (distanceCalculationRequest: DistanceCalculationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distanceCalculationRequest' is not null or undefined
            assertParamExists('calculateDistance', 'distanceCalculationRequest', distanceCalculationRequest)
            const localVarPath = `/calculation/v1/calculate/distance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distanceCalculationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceDistanceApi - functional programming interface
 */
export const CalculationServiceDistanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceDistanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate distance between waypoints
         * @param {DistanceCalculationRequest} distanceCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateDistance(distanceCalculationRequest: DistanceCalculationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistanceCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateDistance(distanceCalculationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceDistanceApi.calculateDistance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceDistanceApi - factory interface
 */
export const CalculationServiceDistanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceDistanceApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate distance between waypoints
         * @param {CalculationServiceDistanceApiCalculateDistanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDistance(requestParameters: CalculationServiceDistanceApiCalculateDistanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<DistanceCalculationResponse> {
            return localVarFp.calculateDistance(requestParameters.distanceCalculationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculateDistance operation in CalculationServiceDistanceApi.
 */
export interface CalculationServiceDistanceApiCalculateDistanceRequest {
    readonly distanceCalculationRequest: DistanceCalculationRequest
}

/**
 * CalculationServiceDistanceApi - object-oriented interface
 */
export class CalculationServiceDistanceApi extends BaseAPI {
    /**
     * 
     * @summary Calculate distance between waypoints
     * @param {CalculationServiceDistanceApiCalculateDistanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculateDistance(requestParameters: CalculationServiceDistanceApiCalculateDistanceRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceDistanceApiFp(this.configuration).calculateDistance(requestParameters.distanceCalculationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

